import React, { useCallback, useState } from 'react';
import ButtonIcon from 'components/IconButton';
import { CreateIcon } from 'Icons';
import { PANEL } from 'utils/constants';
import Portal from 'portal/Portal';
import PropTypes from 'prop-types';
import { EventFollowupButtons } from 'utils/constants/eventStatus';
import EventForm from './baseEventForm';
import { useDispatch } from 'react-redux';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { eventsGridActions } from 'containers/Pages/Events';
import CleanerForm from 'containers/Pages/Tasks/Template/form';
import { v4 } from 'uuid';
import { getLocationValue } from 'utils/DataTransform/Events/eventTransformHelper';

const useStyles = makeStyles(() => ({
  portalForm: {
    display: 'flex',
    height: '85vh',
    width: '65vw',
    position: 'relative',
    transform: 'translate(0%, 0%)',
  },
}));

const FollowupButtonComponent = ({
  view,
  followupEventID: baseEventId,
  parentEventDetails,
}) => {
  const classes = useStyles();
  const [openCleaningModal, setopenCleaningModal] = useState(false);
  const [formProps, setFormProps] = useState({
    values: { id: baseEventId },
  });
  const [openEventModal, setopenEventModal] = useState(false);
  const dispatch = useDispatch();

  // create a followup event and close the form....
  const dispatchCreateFollowupEvent = useCallback(
    ({ event }) => {
      dispatch(
        eventsGridActions.createRowEntry({
          event: { ...event, parentEventId: baseEventId },
        }),
      );
    },
    [dispatch, baseEventId],
  );

  const eventFormProps = {
    values: {
      id: baseEventId,
    },
  };

  const onIconClick = view => {
    if (view === PANEL.CLEANER_TASK) {
      setopenCleaningModal(true);
    } else {
      setopenEventModal(true);
    }
  };

  const setButtonTitle = view => {
    switch (view) {
      case PANEL.CLEANER_TASK:
        return EventFollowupButtons.taskButtonText;

      default:
        return EventFollowupButtons.eventButtonText;
    }
  };

  const createFollowupEvent = ({ event }) => {
    dispatchCreateFollowupEvent({ event });
    setopenEventModal(false);
  };

  return (
    <div>
      <ButtonIcon
        noHorizontalPadding
        title={setButtonTitle(view)}
        component={CreateIcon}
        onClick={() => onIconClick(view)}
        iconProps={{
          fontSize: 'inherit',
        }}
      />
      {openCleaningModal && (
        <Portal id={'portal'} type="modal">
          {
            <Box component={'div'} className={classes.portalForm}>
              <CleanerForm
                closeForm={() => setopenCleaningModal(false)}
                setFormProps={setFormProps}
                formProps={formProps}
                fromEvents={true}
                isTemplate={false}
                formTitle={'Follow-up Tasks'}
                multiSchedule={false}
                disablePresist={true}
              />
            </Box>
          }
        </Portal>
      )}
      {openEventModal && (
        <Portal id={'portal'}>
          {
            <Box component={'div'} className={classes.portalForm}>
              <EventForm
                closeForm={() => {
                  setopenEventModal(false);
                }}
                isFollowup={true}
                formProps={eventFormProps}
                followupEventTitle={setButtonTitle(view)}
                createFollowupEvent={createFollowupEvent}
                disablePresist={true}
                defaultFieldValues={{
                  // default fields for follow tasks carried over from its parent event
                  publicDescription:
                    parentEventDetails.others.rawData.general.descriptions
                      .publicDescription,
                  startTime:
                    parentEventDetails.others.rawData.general.eventStartTime,
                  ...(parentEventDetails.others.rawData.general
                    ?.eventFinishTime && {
                    finishTime:
                      parentEventDetails.others.rawData.general.eventFinishTime,
                  }),
                  locations: getLocationValue(
                    parentEventDetails.others.rawData,
                  ),
                  eventCategory:
                    parentEventDetails.others.rawData.general.category,
                  eventType: {
                    id: v4(), // this is only required for async select and is not sent to the api
                    companyId:
                      parentEventDetails.others.rawData.general
                        .securityCompanyId,
                    typeName: parentEventDetails.others.rawData.general.type,
                    defaultDescription: null,
                    archived: false,
                    category:
                      parentEventDetails.others.rawData.general.category,
                  },
                }}
              />
            </Box>
          }
        </Portal>
      )}
    </div>
  );
};
FollowupButtonComponent.propTypes = {
  view: PropTypes.string,
  titleOfEvent: PropTypes.string,
  followupEventID: PropTypes.string,
  parentEventDetails: PropTypes.object,
};

export default React.memo(FollowupButtonComponent, (prev, curr) => {
  return curr.followupEventID === prev.followupEventID;
});
